import { Message } from "@/types/chat"
import { PlaceSummary } from "@/types/place"
import { WebSearchResult } from "@/types/web-search-result"

import { isBotMessage } from "./message-util"

export interface WebSearchResultForMap {
  messageId: number | string
  structuredResult: string
  searchResult: WebSearchResult
  places: PlaceSummary[]
}

/**
 * Homepage ribbon events belong to no message, so they stand in for one here.
 * The marker, the card's hover and the detail sheet all key off this pair
 * (source + the event's own ref), which is what lets a hovered card light up
 * its pin: the synthetic map ref is built from them on both sides.
 */
export const FOR_YOU_WEB_EVENT_SOURCE = "for-you"

export function messageHasWebSearchResultsForMap(message: Message): boolean {
  if (!isBotMessage(message) || !message.structured_results) return false
  const { events, trails } = message.structured_results
  return (events?.length ?? 0) > 0 || (trails?.length ?? 0) > 0
}

export function collectWebSearchResultsFromMessage(
  message: Message
): WebSearchResultForMap[] {
  if (!isBotMessage(message) || !message.structured_results) return []

  const results: WebSearchResultForMap[] = []
  const messageId = message.id
  const places = message.places ?? []

  message.structured_results.events?.forEach((searchResult, index) => {
    results.push({
      messageId,
      structuredResult: `events:${index}`,
      searchResult,
      places,
    })
  })

  message.structured_results.trails?.forEach((searchResult, index) => {
    results.push({
      messageId,
      structuredResult: `trails:${index}`,
      searchResult,
      places,
    })
  })

  return results
}

export function collectWebSearchResultsForMap(
  messages: Message[],
  inProgressMessage?: Message
): WebSearchResultForMap[] {
  const results = messages.flatMap(collectWebSearchResultsFromMessage)
  if (inProgressMessage) {
    results.push(...collectWebSearchResultsFromMessage(inProgressMessage))
  }
  return results
}
